import React from 'react';
import autoBind from 'react-autobind';
import SectionHeader from '../SectionHeader.jsx';

export default class InSpecieTransferReview extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    _renderHeader() {
        return (<SectionHeader sectionId={this.props.sectionId} handlePencilClick={this.props.handlePencilClick} sectionName={this.props.sectionName} />);
    }
    
    _renderSubSectionMessages() {
        return this.props.sectionMessage.length > 0 
                ? (<div className="row simple-review-row-subsection">
                    <div className="col-xs-12">
                        <div>{this.props.sectionMessage}</div>
                    </div>
                    </div>)
               : null;
    }


    _renderRow(col1, col2){
        return (
            <div className="row">
                <div className="col-xs-4 confirm-ist__title">
                    {col1}
                </div>
                <div className="col-xs-8 text-left">
                    {col2}
                </div>
            </div>
        );
    }
    _renderIst(item, index){
        let rollOverName = <span className="label-header">{index + 1}. {item.rollOverName}</span>;
        let acc = <span className="confirm-ist__account">Acc# {item.accountNumber}</span>;
        return (
            <div key={`ist_confirm_${index}_row`} className="confirm-ist simple-review-row-subsection">
                {this._renderRow(rollOverName, acc)}
            </div>);
    }
    _renderExternalAllocationAsPerFunds(){
        return(
            <div className="row">
                <div className="col-xs-12">
                    <p>External funds invested as per the investment allocation of these fund(s)</p>
                </div>
            </div>
        );
    }
    _renderExternalAllocationAsPerQuestion() {
         return(
            <div className="row">
                <div className="col-xs-12">
                    <p>External funds invested as per your answer to the investment allocation question</p>
                </div>
            </div>
        );
    }
    render() {
        return (
            <section className="confirm-simple-review" id={this.props.sectionId}>
                <div className="container">
                    {this._renderHeader()}
                    {this._renderSubSectionMessages()}
                    {this.props.items.map(this._renderIst, this)}
                    {this.props.externalAccountsAllocatedAsPerFunds ? this._renderExternalAllocationAsPerFunds() : null} 
                    {this.props.externalAccountsAllocatedAsPerQuestion ? this._renderExternalAllocationAsPerQuestion() : null} 
                </div>
            </section>);
    }
}

InSpecieTransferReview.propTypes = {
    items: React.PropTypes.array.isRequired,
    sectionName: React.PropTypes.string.isRequired,
    sectionId: React.PropTypes.string,    
    sectionMessage: React.PropTypes.string,
    externalAccountsAllocatedAsPerFunds: React.PropTypes.bool,
    externalAccountsAllocatedAsPerQuestion: React.PropTypes.bool
};

InSpecieTransferReview.defaultProps = {
    sectionMessage: '',
    allocateExternalFunds: false
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ConfirmDetails/InSpecieTransfer/InSpecieTransferReview.jsx